import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Button } from 'semantic-ui-react';
import { Brikk } from 'components/Brikk';
import { SearchInput } from 'components/form-elements/inputs/SearchInput';
import { Text } from 'components/typography';
import { PageLoader } from 'components/loaders/PageLoader';
import { useGetAccessRules } from 'services/2n/access-rules';
import styles from '../styles.module.scss';
import { useAccessManagement2NModal } from '../AccessManagement2NModalContext/useAccessManagement2NModal';
import { AccessRule } from './components/AccessRule';

export const AccessRules = () => {
  const [keyword, setKeyword] = useState('');
  const { accessRules, isLoading } = useGetAccessRules();
  const intl = useIntl();
  const accessManagement2NModal = useAccessManagement2NModal();

  const filteredAccessRules = !keyword ? accessRules : accessRules.filter(
    accessRule => String((accessRule && (accessRule.Name || accessRule.name)) || '').toLowerCase().includes(keyword.toLowerCase()),
  );

  return (
    <div className={styles.container}>
      <Brikk.Heading
        heading="accessRulesTitle"
      />
      <SearchInput
        placeholder={intl.formatMessage({ id: 'search' })}
        keyword={keyword}
        setKeyword={setKeyword}
      />
      <div className={styles.itemsList}>
        {isLoading && <PageLoader />}
        {
          !isLoading && filteredAccessRules && filteredAccessRules.length > 0
            ? filteredAccessRules.map((accessRule, index) => (
              <AccessRule
                key={(accessRule && (accessRule.Id || accessRule.id)) || index}
                accessRule={accessRule}
              />
            ))
            : !isLoading && (
              <Text
                secondary
                center
                intl="noAccessRulesToDisplay"
                size={16}
              />
            )
        }
      </div>
      <div className={styles.formButtons}>
        <Button
          primary
          disabled={accessManagement2NModal.isAdding.accessRule}
          onClick={() => {
            accessManagement2NModal.updateSelected('accessRule', null);
            accessManagement2NModal.updateAdding('accessRule', true);
          }}
        >
          {intl.formatMessage({ id: 'addNewAccessRule' })}
        </Button>
      </div>
    </div>
  );
};
